'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@common/components';
import { SvgPencil } from '@common/icon';
import Link from 'next/link';
import { ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { ViewModeToggle } from './ViewModeToggle';
export const PolicyFilter = () => {
  const $ = _c(13);
  const myInfo = useAuthStore(_temp);
  let t0;
  if ($[0] !== myInfo) {
    t0 = myInfo || {};
    $[0] = myInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    age,
    subRegion
  } = t0;
  let t1;
  if ($[2] !== subRegion) {
    t1 = subRegion ? <Chip checked={true} className="!h-28 cursor-default !border-Gray-black !bg-Gray-black !p-8 !font-600 !text-Gray-white !typo-caption1">{subRegion}</Chip> : null;
    $[2] = subRegion;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== age) {
    t2 = age ? <Chip checked={true} className="!h-28 cursor-default !border-Gray-black !bg-Gray-black !p-8 !font-600 !text-Gray-white !typo-caption1">만 {age}세</Chip> : null;
    $[4] = age;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href={ROUTES.MY_POLICY_FILTER.pathname} className="flex size-28 items-center justify-center rounded-pill bg-Gray-white" aria-label={"\uD504\uB85C\uD544 \uC218\uC815"}><SvgPencil className="size-14 text-Gray-600" /></Link>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = <div className="flex items-center gap-4">{t1}{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ViewModeToggle />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="flex flex-col gap-12 px-20 py-12"><div className="flex items-center justify-between">{t4}{t5}</div></div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(state) {
  return state.myInfo;
}